/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Mxf_EmbedInputs */



/**
* | output |
* | --- |
* | "MXF Embed" |
*
* @param {Subtitle_Export_Mxf_EmbedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_mxf_embed = /** @type {((inputs?: Subtitle_Export_Mxf_EmbedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Mxf_EmbedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Intégration MXF")
	if (locale === "de") return /** @type {LocalizedString} */ ("MXF-Einbettung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incorporamento MXF")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Встраивание MXF")
	if (locale === "es") return /** @type {LocalizedString} */ ("Incrustar MXF")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("MXF 嵌入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("MXF埋め込み")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एमएक्सएफ एम्बेड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incorporação MXF")
	return /** @type {LocalizedString} */ ("MXF Embed")
});